<template>
    <Popup position="bottom" v-model="show2">
        <Picker
                show-toolbar
                :title="title"
                :columns="columns"
                @confirm="onOk"
                @cancel="onCancel"
        />
    </Popup>
</template>

<script>
    import {Button, Icon, Picker, Popup} from "vant"
    import * as DICT from "@/utils/dict";

    export default {
        props: {
            dictKey: {type: String, required: true},
            title: {type: String, default: "请选择"},
            block: {type: Boolean, default: false},
            show: {type: Boolean, default: false},
            showAll: {type: Boolean, default: false},
        },
        components: {
            Button,
            Popup,
            Picker,
            Icon
        },
        data() {
            return {
                text: '',
                value: '',
                // show2: false,
                columns: []
            };
        },
        computed: {
            show2: {
                get() {
                    return this.show
                },
                set() {
                    this.onCancel()
                }
            },
        },
        methods: {
            onCancel() {
                this.$emit('cancel')
            },
            onOk(item) {
                this.$emit("ok", item);
            },
            initColumns(dictKey) {
                this.columns = DICT.getList(dictKey).map(item => {
                    item.text = item.codeName;
                    return item
                })
                if (this.showAll) {
                    this.columns.unshift({
                        code: "All",
                        codeName: "全部", text: "全部"
                    })
                }
            }
        },
        created() {
            this.initColumns(this.dictKey)
        },
        watch: {
            dictKey(dictKey) {
                this.initColumns(dictKey)
            },
            // show(show) {
            //     this.show2 = show
            // }
        }
    };
</script>

<style lang="less" scoped>
    .btn-content {
        display: flex;
        justify-content: space-around;
        align-items: center;
    }
</style>
